import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file-tray-full-sharp",
  "use": "icon-file-tray-full-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-file-tray-full-sharp\"><title>File Tray Full</title><path d=\"M128 128h256v38H128zM112 192h288v38H112z\" /><path d=\"M448 64H64L32 256v192h448V256zm-12 192H320a64 64 0 01-128 0H76l22-150h316z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol